import { createContext } from 'react';

const menuContext = createContext();

export default menuContext;
